import { useState, useEffect } from "react";
import {
  useAccount,
  useWriteContract,
  useWaitForTransactionReceipt,
} from "wagmi";
import { Address, parseEther } from "viem";
import { NFT_CONTRACT_ADDRESS } from "@/constants/mint";
import { nftAbi } from "@/abi/nftAbi";
import { RATE } from "@/constants/rate";

export const useWhitelistMint = () => {
  const { address, isConnected } = useAccount();
  const { writeContract, data: result } = useWriteContract();
  const [txHash, setTxHash] = useState<Address | undefined>();
  const { isSuccess } = useWaitForTransactionReceipt({
    hash: txHash,
    confirmations: 1,
  });

  const fee = parseEther(RATE.toString());

  useEffect(() => {
    if (result) setTxHash(result);
  }, [result]);

  const handleMint = async () => {
    if (!address) return;
    try {
      writeContract({
        address: NFT_CONTRACT_ADDRESS,
        abi: nftAbi,
        functionName: "whitelistMint",
        value: fee,
      });
    } catch (error) {
      console.error("Transaction send error:", error);
    }
  };

  return {
    isConnected,
    isSuccess,
    handleMint,
  };
};
